import { Card, SkeletonStack } from '@/shared/ui'
import { useProfile } from '@/entities/profile'
import { ProfileForm } from '@/features/profile-edit'

/** Вкладка настроек: из этих полей собирается речь агента. */
export function ProfilePage() {
  const profile = useProfile()

  return (
    <Card
      title="Анкета агента"
      subtitle="Правила речи, паузы и интонации мы берём на себя — от вас нужны факты о бизнесе"
    >
      {profile.isPending ? (
        <SkeletonStack rows={6} height={40} />
      ) : profile.data ? (
        // key по времени сохранения: после успешной записи форма
        // пересоздаётся с новыми данными, и отметка «есть несохранённые
        // правки» не остаётся висеть.
        <ProfileForm key={profile.data.updatedAt} initial={profile.data} />
      ) : (
        <p>Не удалось загрузить анкету</p>
      )}
    </Card>
  )
}
